import React from "react";

import ResumeBarPreSigned from "./HomeComponents/Resume/ResumeBarPreSigned";
import CasaRuufImage from "./HomeComponents/Images/CasaRuuf.png";
import { HomeGreeting } from "../../styles/texts";

import {
  UserData,
  UserBooking,
  SpecificBooking,
} from "../../types/responseTypes";

interface HomePreSignedProps {
  userData: UserData;
  userBooking: UserBooking;
  specificBooking: SpecificBooking;
  //specificBooking?: SpecificBooking | null;
}

const HomePreSigned: React.FC<HomePreSignedProps> = ({
  userData,
  userBooking,
  specificBooking,
}) => {
  console.log("HomePreSigned: ", userData, userBooking, specificBooking);

  return (
    <div>
      <div className="flex flex-col items-center justify-center mb-10">
        <HomeGreeting userData={userData} userBooking={userBooking} />
        <img
          src={CasaRuufImage}
          alt="Casa Ruuf"
          className="w-1/8 md:w-1/8 mb-4"
        />

        {/* Para desarrollo local es util esto hee hee
        <div className="text-3xl font-bold text-gray-800 mb-4">
          Home Pre Signed
        </div>
        */}

        <div className="w-full max-w-xl md:max-w-2xl p-4 rounded-lg bg-white shadow-lg">
          <ResumeBarPreSigned specificBooking={specificBooking} />
        </div>
      </div>
    </div>
  );
};

export default HomePreSigned;
